<template>
  <el-card>
    <el-descriptions :column="1" :title="$t('lang.基础信息')" class="desc-box">
      <el-descriptions-item :label="$t('lang.设备图片')" :colon="false" labelStyle="display: none">
        <img :src="deviceDetail['productPhotoCode'] | filterImg" style="height: 200px; width: 200px" />
      </el-descriptions-item>
      <el-descriptions-item :label="$t('lang.SN码')">{{ deviceDetail['sn'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.品牌')">{{ deviceDetail['brandOwnerName'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.型号')">{{ deviceDetail['productModel'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.子型号')">{{ deviceDetail['productSubModel'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.产品名称')">{{ deviceDetail['productName'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.激活日期')">{{ deviceDetail['activeDateStr'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.APK版本')">{{ deviceDetail['apkEdition'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.MCU版本')">{{ deviceDetail['mcuVersion'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.TP版本')">{{ deviceDetail['tpVersion'] }}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions :column="3" :title="$t('lang.用户信息')" class="desc-box">
      <el-descriptions-item :label="$t('lang.地区')">{{ deviceDetail['countryName'] }}/{{ deviceDetail['provinceName'] }}/{{ deviceDetail['cityName'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.账户')">{{ deviceDetail['userAccount'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.注册时间')">{{ deviceDetail['userCreateTimeStr'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.昵称')">{{ deviceDetail['userNickname'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.性别')">{{ deviceDetail['userGenderName'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.年龄')">{{ deviceDetail['userAge'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.头像')">
        <img :src="deviceDetail['userPortrait'] | filterImg" style="height: 100px; width: 100px" />
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions :column="3" :title="$t('lang.联网信息')" class="desc-box">
      <el-descriptions-item :label="$t('lang.联网状态')">{{ $t(`lang.${deviceDetail['onlineStatusName']}`) }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.联网IP')">{{ deviceDetail['ip'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.最后联网时间')">{{ deviceDetail['lastOnlineTimeStr'] }}</el-descriptions-item>
    </el-descriptions>
  </el-card>
</template>

<script>
export default {
  name: "TestDeviceEdit",
  components: {},
  data() {
    return {
      api: {
        detail: this.$api.testDevice.detail,
      },

      deviceDetail: {},
      that: this,
    }
  },
  methods: {
    handleGetDetail() {
      const vm = this;
      vm.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (res) {
        if(res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.deviceDetail = res.data.data['device'];
      });

    }

  },

  created() {

    this.handleGetDetail();

  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}

.desc-box {
  margin-bottom: 34px;
}


</style>
